import React from "react";

type LogLevelBadgeProps = {
  level?: string | null;
};

const LEVEL_CLASS: Record<string, string> = {
  error: "logs-level-badge--error",
  warn: "logs-level-badge--warn",
  info: "logs-level-badge--info",
  debug: "logs-level-badge--debug",
  http: "logs-level-badge--http",
  verbose: "logs-level-badge--muted",
  silly: "logs-level-badge--muted",
};

export const LogLevelBadge: React.FC<LogLevelBadgeProps> = ({ level }) => {
  const normalized = (level || "unknown").toLowerCase();
  const className = LEVEL_CLASS[normalized] || "logs-level-badge--muted";

  return (
    <span className={`logs-level-badge ${className}`}>
      {normalized}
    </span>
  );
};
